import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79bcee5a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'Ksiosminigame'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList2 = ref([]); // 分成比例
    const quickWorkerRef = ref(null);
    const quickWorkerForm = reactive({
      divide: '0.8',
      callbackSecret: '',
      paySecret: '',
      pkg: '',
      appId: ''
    });
    const validateForm = () => {
      var _quickWorkerRef$value;
      (_quickWorkerRef$value = quickWorkerRef.value) === null || _quickWorkerRef$value === void 0 || _quickWorkerRef$value.validate().then(() => {
        emit('submitForm', quickWorkerForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        quickWorkerForm.pkg = n.pkg;
        quickWorkerForm.appId = n.appId;
        quickWorkerForm.callbackSecret = n.callbackSecret;
        quickWorkerForm.paySecret = n.paySecret;
        quickWorkerForm.divide = n.divide;
        quickWorkerForm.id = n.id;
        divideList2.value = n.rateList;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: quickWorkerForm,
        ref_key: "quickWorkerRef",
        ref: quickWorkerRef,
        rules: __props.rules,
        name: "gp-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: quickWorkerForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => quickWorkerForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: quickWorkerForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => quickWorkerForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "callbackSecret",
          label: "回调密钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: quickWorkerForm.callbackSecret,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => quickWorkerForm.callbackSecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "paySecret",
          label: "支付密钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: quickWorkerForm.paySecret,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => quickWorkerForm.paySecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: quickWorkerForm.divide,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => quickWorkerForm.divide = $event),
            options: divideList2.value
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});